import { Check, Lock } from "lucide-react";
import { PIPELINE, SIDE_STAGES, ADMIN_STAGES, STAGE_META } from "@/utils/quoteStages";

export const QuoteStageTracker = ({ quote, isAdmin, busy, onChange }) => {
  const current = quote.status === "converted" ? "accepted" : quote.status;
  const idx = PIPELINE.indexOf(current);
  const locked = (s) => (ADMIN_STAGES.includes(s) || ADMIN_STAGES.includes(current)) && !isAdmin;

  return (
    <div className="space-y-2" data-testid={`quote-tracker-${quote.id}`}>
      <ol className="flex items-center gap-0.5">
        {PIPELINE.map((s, i) => {
          const done = idx >= 0 && i <= idx;
          const isCurrent = s === current;
          return (
            <li key={s} className="flex-1 min-w-0">
              <button
                type="button" disabled={busy || isCurrent || locked(s)} onClick={() => onChange(s)}
                title={locked(s) ? "Admin only" : `Mark as ${STAGE_META[s].label}`}
                className={`w-full flex items-center justify-center gap-1 h-7 px-1 text-[10px] font-semibold border transition-colors first:rounded-l-md last:rounded-r-md
                  ${done ? `${STAGE_META[s].cls}` : "bg-white text-slate-500 border-slate-200 hover:bg-slate-50"}
                  ${isCurrent ? "ring-2 ring-offset-1 ring-slate-900/20" : ""} disabled:cursor-default ${locked(s) && !done ? "opacity-60" : ""}`}
                data-testid={`quote-stage-${s}-${quote.id}`}
              >
                {done && !isCurrent && <Check size={10} />}
                {locked(s) && !done && <Lock size={9} />}
                <span className="truncate">{STAGE_META[s].label}</span>
              </button>
            </li>
          );
        })}
      </ol>
      <div className="flex items-center gap-1.5 flex-wrap">
        <span className="text-[10px] text-muted-foreground">Or mark:</span>
        {SIDE_STAGES.map((s) => (
          <button
            key={s} type="button" disabled={busy || s === current || locked(s)} onClick={() => onChange(s)}
            className={`rounded-full border px-2 py-0.5 text-[10px] font-medium transition-colors ${s === current ? STAGE_META[s].cls : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50"} disabled:opacity-60 disabled:cursor-default`}
            title={locked(s) ? "Admin only" : `Mark as ${STAGE_META[s].label}`}
            data-testid={`quote-stage-${s}-${quote.id}`}
          >
            {locked(s) && <Lock size={8} className="inline mr-0.5" />}{STAGE_META[s].label}
          </button>
        ))}
      </div>
    </div>
  );
};
